module.exports = __webpack_public_path__ + "img/file-upload-icon.4835d0dd.svg";